import PropTypes from 'prop-types';
import './UnreadBadge.css';

/**
 * A component to display a count of unread messages in a red circle.
 */
const UnreadBadge = ({ count }) => {
  if (count <= 0) return null;
  const label = count > 99 ? '99+' : count;
  return (
    <div className="unread-badge">
      <span className="unread-badge-count">{label}</span>
    </div>
  );
};

UnreadBadge.propTypes = {
  /** The number to display inside the badge. */
  count: PropTypes.number.isRequired,
};

export default UnreadBadge;